var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 19.5H6.425L16.2 9.725L14.775 8.3L5 18.075V19.5ZM4 21.5C3.71667 21.5 3.47933 21.404 3.288 21.212C3.09667 21.02 3.00067 20.7827 3 20.5V18.075C3 17.8083 3.05 17.554 3.15 17.312C3.25 17.07 3.39167 16.8577 3.575 16.675L16.2 4.075C16.4 3.89167 16.621 3.75 16.863 3.65C17.105 3.55 17.359 3.5 17.625 3.5C17.891 3.5 18.1493 3.55 18.4 3.65C18.6507 3.75 18.8673 3.9 19.05 4.1L20.425 5.5C20.625 5.68333 20.7707 5.9 20.862 6.15C20.9533 6.4 20.9993 6.65 21 6.9C21 7.16667 20.954 7.421 20.862 7.663C20.77 7.905 20.6243 8.12567 20.425 8.325L7.825 20.925C7.64167 21.1083 7.429 21.25 7.187 21.35C6.945 21.45 6.691 21.5 6.425 21.5H4ZM15.475 9.025L14.775 8.3L16.2 9.725L15.475 9.025Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPen);
export default __webpack_public_path__ + "static/media/editPen.6f228834db5dcb7e9fc0fb8fa682eb12.svg";
export { ForwardRef as ReactComponent };